"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationAssistance = function IllustrationAssistance() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "66",
    height: "65",
    fill: "none",
    viewBox: "0 0 66 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    x: "0.263",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#D5CCDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M8 48h50"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M24.263 42H42.263000000000005V48H24.263z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M33.263 20v5M47.263 34h-5M24.263 34h-5M43.163 24.1l-3.536 3.536M26.9 27.636l-3.536-3.535M27.263 42h12v-5a6 6 0 00-6-6v0a6 6 0 00-6 6v5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M30 37a3 3 0 013-3"
  }));
};

var _default = IllustrationAssistance;
exports.default = _default;